<script>
import { mapState } from 'vuex';

export default {
    name: 'AmplitudeHandler',
    computed: {
        ...mapState('Auth', ['user']),
    },
    watch: {
        user: {
            async handler(newUser) {
                if (newUser && this.$amplitude) {
                    const userId = newUser.id.toString();

                    this.$amplitude.setDeviceId(userId);
                    this.$amplitude.setUserId(userId);

                    if (this.$syncAmplitudeUserProfile) {
                        await this.$syncAmplitudeUserProfile(newUser);
                    }
                }
            },
            immediate: true,
        },
    },
    render() {
        return null;
    },
};
</script>
